import React, {memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/product-summary"
import connect from "./connect"
import {TextModel} from "../../models/Text"

export interface PriceProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    tooltipTitle: string
    saleJacketPrice?: string | null
    wasJacketPrice?: string | null
    jacketPrice: string
    suitPrice: string
    wasSuitPrice?: string | null
    saleSuitPrice?: string | null
    trouserPrice: string
    wasTrouserPrice?: string | null
    saleTrouserPrice?: string | null
    text: TextModel
    jacketsHasSale: boolean
    trousersHasSale: boolean
    suitPriceAriaLabel: string
    suitJacketPriceAriaLabel: string
    suitTrousersPriceAriaLabel: string
    brandedMarkdownSalePrice: boolean
}

export const SuitPrice = memo(
    ({
        templating,
        tooltipTitle,
        trouserPrice,
        wasTrouserPrice,
        saleTrouserPrice,
        suitPrice,
        wasSuitPrice,
        saleSuitPrice,
        jacketPrice,
        wasJacketPrice,
        saleJacketPrice,
        text,
        jacketsHasSale,
        trousersHasSale,
        suitPriceAriaLabel,
        suitJacketPriceAriaLabel,
        suitTrousersPriceAriaLabel,
        brandedMarkdownSalePrice,
    }: PriceProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        const wasSuitPriceText = `${text.price.was} ${wasSuitPrice}`
        const saleSuitPriceText = `${text.price.now} ${saleSuitPrice}`
        const wasTrouserPriceText = `${text.price.was} ${wasTrouserPrice}`
        const saleTrouserPriceText = `${text.price.now} ${saleTrouserPrice}`
        const wasJacketPriceText = `${text.price.was} ${wasJacketPrice}`
        const saleJacketPriceText = `${text.price.now} ${saleJacketPrice}`
        const suitsHasSale = jacketsHasSale || trousersHasSale

        return (
            <ComponentName
                tooltipTitle={tooltipTitle}
                trouserPrice={trouserPrice}
                saleTrouserPrice={saleTrouserPrice}
                suitPrice={suitPrice}
                saleSuitPrice={saleSuitPrice}
                jacketPrice={jacketPrice}
                saleJacketPrice={saleJacketPrice}
                text={text}
                jacketsHasSale={jacketsHasSale}
                trousersHasSale={trousersHasSale}
                suitPriceAriaLabel={suitPriceAriaLabel}
                suitJacketPriceAriaLabel={suitJacketPriceAriaLabel}
                suitTrousersPriceAriaLabel={suitTrousersPriceAriaLabel}
                brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                wasSuitPriceText={wasSuitPriceText}
                saleSuitPriceText={saleSuitPriceText}
                wasTrouserPriceText={wasTrouserPriceText}
                saleTrouserPriceText={saleTrouserPriceText}
                wasJacketPriceText={wasJacketPriceText}
                saleJacketPriceText={saleJacketPriceText}
                suitsHasSale={suitsHasSale}
            />
        )
    },
)
SuitPrice.displayName = "SuitPrice"

export default connect(SuitPrice)
